export const EN = {
    WELCOME_MESSAGE: 'GWR v2.1.19b',
    DASHBOARD_WELCOME: 'Welcome',
    SEARCH: 'Search',
    WORKFLOW: 'Workflow',
    PUBLISH: "Publish",
    READY: "Ready",
    ARCHIVE: "Archive",
    PREPUBLISHED_DASHBOARD: 'Prepublished',
    IMAGE_FIELD: 'Has image',
    VIDEO_FIELD: 'Has video',
    AUDIO_FIELD: 'Has audio',
    EDITOR_FIELD: 'Editor',
    CHECK_FIELD: 'Check',
    CLEAR: 'Clear',
    DOCUMENTS: 'Documents',
    DASHBOARD: 'Dashboard',
    COMMENTS: 'Comments',
    USERS: 'Users',
    PAGES: 'Pages',
    WIDGETS: 'Widgets',
    WTYPE_ALL: 'All widgets',
    WTYPE_MAIN_PAGE: 'Main page',
    WTYPE_RUSSIAN_LANGUAGE: 'Russian language',
    WTYPE_RUSSIAN_CONTENT: 'Russian content',
    WTYPE_LEARN_RUSSIAN: 'Stories',
    WTYPE_HELP_INFORMATION: 'Help information',
    BANNERS: 'Banners',
    PUSH: 'Push notification',
    INSTRUMENTS: 'Instruments',
    SERVICE_MAIL_LOGS: 'Mail logs',
    DATE: 'Date',
    SUBJECT: 'Subject',
    SERVICE_MAIL_KIND: 'Letter',
    SERVICE_MAIL_ATTEMPTS: 'Attempts',
    SERVICE_MAIL_ERROR: 'Error',
    SERVICE_MAIL_LOGS_LOAD_ERROR: 'Failed to load mail logs',
    SERVICE_MAIL_KIND_SUBSCRIBE: 'Subscription confirmation',
    SERVICE_MAIL_KIND_SUBSCRIBE_REMEMBER: 'Subscription reminder',
    SERVICE_MAIL_KIND_PASSWORD_RECOVERY: 'Password recovery',
    SERVICE_MAIL_KIND_REGISTRATION: 'Registration',
    SERVICE_MAIL_KIND_REGISTRATION_REMEMBER: 'Registration reminder',
    COLLAGE_MAKER: 'Collage builder',
    REDIRECTS: 'Redirects',
    MEDIA_GALLERY_LIST: 'Media gallery',
    CONVERTER: 'Video converter',
    WIDGETS_LIST: 'Widgets',
    CREATE: 'Create',
    TITLE: 'Title',
    WIDGET_VIEW_TITLE: 'Preview',
    PUBLISHED: 'Published',
    DOC_TYPES: 'Doc types',
    DOCS: 'Docs count.',
    WIDGET_VIEW: 'Template',
    ACTIONS: 'Actions',
    WIDGET_POSITION: 'Position',
    RUSSIAN_CONTENT: 'Content',
    FILMS: 'Films',
    PROPERTY: 'Property',
    MUSIC: 'Music',
    BOOKS: 'Books',
    PERFORMING_ARTS: 'Performing Arts',
    PA_GENRE: 'Genre',
    PA_GENRE_REQUIRED: 'Select a genre',
    PA_GENRE_CONTEMPORARY: 'Contemporary drama',
    PA_GENRE_SOVIET: 'Soviet drama',
    PA_GENRE_BALLET: 'Ballet',
    PA_GENRE_OPERA: 'Opera',
    PA_GENRE_MUSICAL: 'Musicals',
    PA_GENRE_CHILDREN: 'Children’s plays',
    PA_PREMIERE_YEAR: 'Year of premiere',
    PA_BASED_ON_AUTHOR: 'Based on: author',
    PA_BASED_ON_TITLE: 'Based on: work',
    PA_BASED_ON_YEAR: 'Based on: year',
    PA_ROOT_CATEGORY: 'Root category',
    PA_CATEGORY: 'Category',
    PA_PRODUCTIONS: 'Productions',
    PA_PRODUCTION: 'Production',
    PA_ADD_PRODUCTION: 'Add production',
    PA_THEATER: 'Theater',
    PA_THEATER_REQUIRED: 'Theater is required',
    PA_SUMMARY_REQUIRED: 'Summary is required',
    PA_PREMIERE_YEAR_REQUIRED: 'Year of premiere is required',
    PA_PRODUCTION_YEAR_REQUIRED: 'Year of production is required',
    PA_DURATION_REQUIRED: 'Running time is required',
    PA_WATCH_URL_REQUIRED: 'Watch link is required',
    PA_COPYRIGHT_REQUIRED: 'Copyright is required',
    PA_PRODUCTION_YEAR: 'Year of production',
    PA_DURATION: 'Running time (minutes)',
    PA_WATCH_URL: 'Watch link',
    PA_WATCH_LINK_TITLE: 'Version title',
    PA_WATCH_LINK_URL: 'Link',
    PA_ADD_WATCH_LINK: 'Add link',
    PA_COPYRIGHT: 'Copyright',
    PA_COMPOSER: 'Composer',
    PA_LIBRETTIST: 'Librettist',
    PA_SCREENWRITER: 'Screenwriter',
    PA_ACTS: 'Number of acts',
    PA_DIRECTOR: 'Director',
    PA_CAST: 'Cast',
    MUSIC_YEAR: 'Year of composition',
    MUSIC_YEAR_TO: 'Year of composition (to)',
    MUSIC_YEAR_REQUIRED: 'Year of composition is required',
    MUSIC_COMPOSER: 'Composer',
    MUSIC_COMPOSER_REQUIRED: 'Composer is required',
    MUSIC_BASED_ON_BOOK: 'Based on: book',
    MUSIC_PERFORMANCES: 'Performances',
    MUSIC_PERFORMANCE: 'Performance',
    MUSIC_ADD_PERFORMANCE: 'Add performance',
    MUSIC_INSTITUTION: 'Musical institution',
    MUSIC_PERFORMERS: 'Performers',
    MUSIC_PARTS: 'Number of parts',
    MUSIC_LISTEN: 'Listen',
    MUSIC_LISTEN_REQUIRED: 'Listen link is required',
    CONTENT_PERFORMANCES: 'Performances',
    MUSEUM: 'Museum',
    RUSSIAN_LANGUAGE: 'Language',
    LEARN_RUSSIA: 'Stories',
    USEFUL_INFORMATION: 'Info',
    COURSES: 'Courses',
    TESTS: 'Tests',
    LEARN_TEXT: 'Articles',
    LEARN_MEMS: 'Memes',
    LEARN_VIDEOS: 'Videos',
    ARTICLES: 'Articles',
    CATEGORIES: 'Categories',
    TRIPS: 'Trips',
    EMPTY_DOCUMENTS: 'No data',
    DATABASE: 'Database',
    LANGUAGES: 'Languages',
    LANGUAGES_LIST: 'Languages',
    TAGS: 'Tags',
    TRENDS: 'Trends',
    AUTHORS: 'Authors',
    CREATE_BTN: 'Add',
    TITLE_OR_URL: 'Search request',
    FLAG: 'Flag',
    DOCUMENT_CREATED: 'Document has been created',
    LANGUAGES_EDIT: 'New lang.',
    LANG_TITLE: 'Lang title',
    LANGUAGE_RFC_CODE: 'Language Code',
    I18N: 'Translates',
    I18N_PLACEHOLDER: 'Translate placeholders',
    UPDATE_DOCUMENT: 'Save',
    LOADING_DOCUMENTS: 'Loading',
    SLUG: 'Slug',
    COLOR: 'Color',
    LANGS: 'Languages',
    UPDATED_AT: 'Updated at',
    CATEGORY_LIST: 'Categories',
    CATEGORY_EDIT: 'Category',
    SELECT_LANGUAGES: 'Languages',
    LANGUAGES_INCLUDE: 'Display at language',
    CATEGORY: 'Category',
    AUTHORS_PLACEHOLDER: 'Choose authors',
    SEO_AND_VIEW: 'Seo and settings',
    VIEW_FIELD: 'View',
    SEO_TITLE: 'Seo title',
    SEO_DESCRIPTION: 'Seo description',
    REDIRECT_TO: 'Redirect',
    FILMS_DESCRIPTION: 'Descriptions',
    FILMS_TITLE_DESCRIPTION: 'Title',
    FILMS_SHORT_DESCRIPTION: 'Short description',
    COVER_DESKTOP: 'Horizontal cover',
    COVER_MOBILE_CLEAN: 'Vertical cover',
    VIDEO: 'Video',
    UPLOAD_NEW: 'Upload',
    UPLOAD_SEL: 'Archive',
    UPLOAD_TEXT: 'Drag or choose file',
    FILMS_AUDIO_LANGS: 'Audios',
    FILMS_SUBTITLE_LANGS: 'Subtitles',
    PUBLISH_ACTION: 'Publish',
    DOC_STATUS: 'Status',
    UNPUBLISHED: 'Unpublished',
    UNPUBLISH_ACTION: 'Unpublish',
    CREATE_BY: 'Created by',
    UPDATED_BY: 'Updated by',
    AT: 'at',
    MOVE_TYPE: 'Move',
    STATUS: 'Status',
    NEED_PHOTO: 'Photo',
    NEED_VIDEO: 'Video',
    NEED_SUBS: 'Subtitles',
    NEED_AUDIO: 'Audios',
    NEED_CHECK_TITLE: 'Editor check',
    NO_HISTORY: 'Empty history',
    MEDIA_TITLE: 'Title',
    FILL_MEDIA_TITLE: 'Title',
    MEDIA_SOURCE: 'Source',
    MEDIA_COPYRIGHT: 'Copyright',
    MEDIA_COPYRIGHT_URL: 'Copyright URL',
    MEDIA_DELETE: 'Delete',
    MEDIA_UPLOAD: 'Upload',
    CROP: 'Crop',
    SUCCESS_SET_LOCK: 'Material has been locked',
    FILMS_EDIT: 'Films',
    PUBLISHED_AT: 'Published at',
    'MEDIA.EDIT': 'Edit media',
    'MEDIA.DELETE': 'Delete media',
    UPLOAD_NEW_VIDEO: 'Upload video',
    UPLOAD_SEL_VIDEO: 'Archive',
    LANGUAGE: 'Language',
    SUMMARY: 'Summary',
    COVER_LABEL: 'Cover',
    TEXT: 'Text',
    EXPORT_TO: 'Export to',
    PUBLISH_AT_DZEN: 'Yandex dzen',
    PUBLISH_AT_RSS: 'Rss feed',
    PUBLISH_AT_GOOGLE: 'Google producer',
    FRENCH_QUOTES: 'French quotes',
    MIDDLE_DASH: "Middle dash",
    LONG_DASH: "Long dash",
    EDITOR_INSERT_MEDIA: "Insert media",
    READMORE: "Insert read more",
    INSERT_IMAGE: 'Image',
    INSERT_VIDEO: 'Video',
    INSERT_EXTERNALVIDEO: "External video",
    INSERT_CODE: 'Embed code',
    UPLOAD: 'Upload',
    SELECT_MEDIA: 'Archive',
    INSERT: 'Insert',
    ADD: 'Add',
    DATABASE_LIST: 'Document settings',
    SELECT_CATEGORIES: 'Select categories',
    SELECT_TAGS: 'Select tags',
    SELECT_TRENDS: 'Select trends',
    PAGE_LIST: 'Pages',
    FILMS_LIST: "Films",
    SELECT_CATEGORY: 'Fill category',
    SELECT_AUTHOR: 'Fill author',
    DATE_FROM: 'Published date from',
    DATE_TO: 'Published date to',
    MUSIC_LIST: 'MUSIC',
    BOOKS_LIST: 'BOOKS',
    ONLINE_PERFORMANCES_LIST: 'Online performance',
    ONLINE_PERFORMANCES: 'Online performance',
    MUSEUM_LIST: 'MUSEUM',
    RUSSIAN_COURSES_LIST: 'Courses',
    TESTS_LIST: 'Tests',
    RUSSIAN_LTEXT_LIST: 'Articles',
    RUSSIAN_LMEMS_LIST: 'Memes',
    RUSSIAN_LVIDEOS_LIST: 'Videos',
    CATEGORIES_LIST: 'Categories',
    TAGS_LIST: 'Tags',
    TRENDS_LIST: 'Trends',
    AUTHORS_LIST: 'Authors',
    MEDIAGALLERY_TYPE_IMAGE: "Image",
    MEDIAGALLERY_TYPE_COVER: "Cover",
    MEDIAGALLERY_TYPE_VIDEO: "Video",
    MEDIAGALLERY_OBJECT: "Total media",
    MEDIAGALLERY_FILL_SEARCH: "Title, copyright ...",
    ARTICLES_LIST: "Articles",
    CHOOSE_LANGUAGES: "Choose languages",
    CHOOSE_LANGUAGE: "Choose language",
    SELECT_WORKFLOW: "Choose status",
    N_NEED_PHOTO: 'Need photo',
    N_NEED_VIDEO: 'Need video',
    SEARCH_PLACEHOLDER: 'Search query',
    PREPUBLISHED_STATUS: 'Prepublished',
    ARTICLES_EDIT: 'Edit',
    WIDGET_TITLE: 'Widget title',
    ADMIN_WIDGET_TITLE: 'Widget title (admin panel)',
    ADMIN_WIDGET_CODE: 'Widget id',
    MAX_SIZE: 'Max documents count',
    WIDGET_TYPE: 'Widget position',
    TYPE_LANGUAGES: 'Languages',
    TYPE_CATEGORY: 'Category (DB)',
    TYPE_USEFUL_CATEGORIES: 'Useful Categories',
    TYPE_RUSSIAN_COURSES: 'Russian courses',
    TYPE_TAGS: 'Tags',
    TYPE_TRENDS: 'Trends',
    TYPE_AUTHORS: 'Authors',
    TYPE_ARTICLES: 'Articles (LR)',
    TYPE_CATEGORIES: 'Category (LR)',
    TYPE_BANNERS: 'Banner',
    WIDGET_TYPE_MAIN: 'Main page',
    WIDGET_TYPE_LEARN_RUSSIAN: 'Content',
    WIDGET_TYPE_RUSSIAN_LANGUAGE: 'Language',
    WIDGET_TYPE_RUSSIAN_CONTENT: 'Content',
    WIDGET_TYPE_USEFUL_INFO: 'Info',
    WIDGET_UPDATED: 'Widget has been updated',
    WIDGETS_EDIT: 'Edit',
    PREVIEW: 'Open document',
    SAVE: 'Save',
    DOCS_NOT_FOUND: 'Documents not found',
    WIDGET_DISPLAY_TITLE: 'Show title',
    LANGUAGE_DOMAIN: 'Domain',
    FILL_URL: 'ru.example.com',
    WIDGET_ADD_TITLE: 'New widget',
    DISPLAY_DROPDOWN_TITLE: 'Title in language selector',
    METRICACOUNTER: 'YaCounter id',
    RTANALYTICS: 'RTAnalytics',
    RTANALYTICS_REQUIRED: 'Fill RTAnalytics',
    WTYPE_TYPE_MENU: "Menu",
    SOURCE: "Source",
    DOWNLOAD_REPORT: "Download report",
    MEDIA_DESCRIPTION: 'Description',
    MEDIA_KEYWORDS: 'Keywords',
    MEDIA_SOURCES: 'Sources',
    MEDIA_MAX_WIDTH: 'Max width',
    MEDIA_INFOGRAPHIC: 'Infographic',
    EDIT_MEDIA: 'Edit media',
    WIDGET_LINK: "Link from title",
    WIDGET_URL_REQUIRED_PLACEHOLDER: "fill widget url",
    TYPE_FILMS: "Films",
    "TYPE_MUSIC": "Music",
    "TYPE_BOOKS": "Books",
    "TYPE_BOOK": "Books",
    "WIDGET_TYPE_BOOKS": "Books",
    "TYPE_ONLINE_PERFORMANCES": "Online perfomance",
    "TYPE_MUSEUM": "Museum",
    "TYPE_TESTS": "Test",
    "TYPE_RUSSIAN_LTEXT": "Article (courses)",
    "TYPE_RUSSIAN_LMEMS": "Mems (courses)",
    "TYPE_RUSSIAN_LVIDEOS": "Videos (courses)",
    "TYPE_USEFUL_ARTICLES": "Article (useful)",
    "TYPE_TRIPS": "Trips (useful)",
    "DISPLAY_PROPS": "Display property",
    "HIDE_COVER": "Hide cover",
    "EDIT": "Edit document",
    "VIEW": "View document",
    "DELETE": "Delete document",
    "AUTHOR": "Authors",
    "CREATED_BY": "Created by",
    "FRONTEND_URL": "Frontend url",
    "UNPUBLISH": "Unpublish",
    "YOU_ARE_SURE": "You are sure?",
    "PREPUBLISH": "Prepublish",
    "UN_PREPUBLISH": "Remove from prepublish",
    "MATERIAL_WILL_REMOVE_PREPUBLISH": "Document will remove from prepublish",
    "MATERIAL_WILL_PREPUBLISH": "Material will set as prepublished",
    "ERROR_PREPUBLISH": "Failed to save document as prepublished",
    "DOCUMENT_UPDATED": "Document has been updated",
    "REPORTS": "Reports",
    "DIGITAL": "digital.gov.ru",
    "REGISTRATIONS": "Registrations",
    "INSTAGRAM_FACEBOOK": "Instagram/Facebook",
    "META_SOURCES_LOAD_ERROR": "Failed to load Instagram/Facebook report",
    "TOTAL_REGISTRATIONS": "Total registrations",
    "REGISTRATIONS_BY_MONTH": "Registrations by month",
    "REGISTRATIONS_BY_LANGUAGE": "Registrations by language",
    "REGISTRATIONS_COUNT": "Registrations",
    "REGISTRATIONS_REPORT_LOAD_ERROR": "Failed to load registrations report",
    "REGISTRATIONS_REPORT_EMPTY": "Registrations report is unavailable",
    "REPORT_YEAR": "Year",
    "MONTH": "Month",
    "RETRY": "Retry",
    "JANUARY": "January",
    "FEBRUARY": "February",
    "MARCH": "March",
    "APRIL": "April",
    "MAY": "May",
    "JUNE": "June",
    "JULY": "July",
    "AUGUST": "August",
    "SEPTEMBER": "September",
    "OCTOBER": "October",
    "NOVEMBER": "November",
    "DECEMBER": "December",
    "EMAIL": "Email",
    "SUBSCRIBERS": "Subscribers",
    "SUBSCRIBERS_TOTAL": "All subscriptions",
    "SUBSCRIBERS_ACTIVE": "Active subscribers",
    "SUBSCRIBERS_PENDING": "Pending confirmation",
    "SUBSCRIBERS_SEARCH_EMAIL": "Search by email",
    "SUBSCRIBERS_LOAD_ERROR": "Failed to load subscribers",
    "SUBSCRIPTION_TYPES": "Newsletter types",
    "SUBSCRIPTION_TYPES_REQUIRED": "Select at least one newsletter type",
    "SUBSCRIBER_APPROVED": "Approved",
    "SUBSCRIBER_PENDING": "Pending",
    "SUBSCRIBER_ADD": "Add subscriber",
    "SUBSCRIBER_EMAIL_REQUIRED": "Email is required",
    "SUBSCRIBER_CREATED": "Subscriber has been added",
    "SUBSCRIBER_CREATE_ERROR": "Failed to add subscriber",
    "SUBSCRIBER_UPDATED": "Subscriber preferences have been updated",
    "SUBSCRIBER_UPDATE_ERROR": "Failed to update subscriber",
    "SUBSCRIBER_DELETED": "Subscriber has been removed",
    "SUBSCRIBER_DELETE_ERROR": "Failed to remove subscriber",
    "SUBSCRIBER_DELETE_CONFIRM": "Remove this subscriber from all newsletters?",
    "BACK_TO_NEWSLETTER": "Back to newsletter",
    "NEWSLETTER_SETTINGS": "Newsletter settings",
    "NEWSLETTER_SETTINGS_LOAD_ERROR": "Failed to load newsletter settings",
    "NEWSLETTER_SETTINGS_SAVE_ERROR": "Failed to save newsletter settings",
    "NEWSLETTER_SETTINGS_SAVED": "Newsletter settings have been saved",
    "NEWSLETTER_TITLE": "Newsletter title",
    "NEWSLETTER_TITLE_REQUIRED": "Newsletter title is required",
    "NEWSLETTER_SENDER_NAME": "Sender name",
    "NEWSLETTER_SENDER_NAME_REQUIRED": "Sender name is required",
    "NEWSLETTER_SHOW_DATE": "Show date in email header",
    "INSERT_AUDIO": "Audio",
    "ROOT_CATEGORY": "Root category",
    "UNITS": "Units",
    "LESSONS": "Lessons",
    "UNITS_LIST": "Units",
    "COURSES_LIST": "Courses",
    "UNITS_EDIT": "Unit edit",
    "COURSE": "Course",
    "SELECT_COURSE": "Choose course",
    "LESSONS_LIST": "Lessons",
    "UNIT": "Unit",
    "SELECT_UNITS": "Choose unit",
    "LESSONS_SORT": "Lessons sort",
    "UNITS_SORT": "Units sort",
    "TESTS_COMPONENT": "Tests",
    "TEST_TYPE": "Test type",
    "CHOOSE_TEST_TYPE": "Test type",
    "TEST_TYPE_TRANSLATE": "Translate text",
    "TEST_TYPE_MATCH_PICTURE": "Match text and image",
    "TEST_TYPE_LISTEN_AND_WRITE": "Listen text and write words",
    "TEST_TYPE_MATCH_TEXT": "Match text and words",
    "TEST_TYPE_MATCH_TEXT_DIALOG": "Match words with dialog",
    "TEST_TYPE_GROUP_WORDS": "Group words",
    "TEST_TYPE_WRITE_PICTURE": "Match text and image",
    "TEST_TYPE_CHOOSE_CORRECT": "Choose correct",
    "ADD_QUESTION": "Add question",
    "QUESTION": "Question",
    "WEEKLY": "Weekly",
    "ADD_ANSWER": "Add answers",
    "ANSWERS": "Answers",
    "IS_CORRECT_ANSWER": "Is correct",
    "IS_EXAMPLE_ANSWER": "Is example",
    "ANSWER_PLACEHOLDER": "Fill answer",
    "CHANGE_LANGUAGE": "Change language",
    "TEST_TYPE_LISTEN_AND_WRITE_DIALOG": "Listen and manual write",
    "MEDIAGALLERY_SELECT_TYPE": "Select media type",
    "MEDIAGALLERY_TYPE_PDF": "PDF",
    "MEDIAGALLERY_TYPE_AUDIO": "AUDIO",
    "SORT_RELEVANCE": 'Relevance',
    "SORT_PUBLISHED_AT": "Published at",
    "SORT_CREATED_AT": "Created at",
    "SORT_UPDATED_AT": "Updated at",
    "AUTONUMBS": "Automate numbers",

    "EMAIL_SENDER": "Newsletter",
    "DAILY": "Daily",
    "WTYPE_TYPE_EMAIL": "Email",
    "MEDIA_SELECTION": "Selection",
    "PERSONS": "Persons",
    "THEATERS": "Theaters",
    "PERSON_LIST": "Persons",
    "GENRES": "Genres",
    "COPYRIGHT": "Copyright",
    "MEDIA_SELECTION_LIST": "Selection",
    "AUTHOR_NAME": "Name",
    "AUTHOR_DESCRIPTION": "Description",
    "AUTHOR_COVER": "Cover",
    "POSITION": "Position",
    "GENRE_LIST": "Genres",
    "COPYRIGHT_LIST": "Copyrights",
    "CROSS_FILMS": "Films on other languages",
    "CROSS_BOOK": "Books on other languages",
    "FILM_LINK": "Links to films/serial",
    "COPYRIGHTS": "Copyrights",
    "DIRECTOR": "Director",
    "CAST": "Cast",
    "SELECTION": "Selection",
    "FILM_YEAR": "Film/Serial year",
    "FILM_DURATION": "Film/Serial duration in minutes",
    "PUBLISHER": "Publisher",
    "TRANSLATOR": "Translator",
    "BOOK_YEAR": "Book year",
    "IS_FREE": "Its free",

    "WTYPE_TYPE_BOOKS": "Books",
    "WTYPE_TYPE_FILMS": "Films",
    "WTYPE_TYPE_PERFORMING_ARTS": "Performing Arts",
    "WTYPE_TYPE_MUSIC": "Music",
    "WIDGET_TYPE_MUSIC": "Music",
    "WIDGET_TYPE_PERFORMING_ARTS": "Performing Arts",

    "TYPE_FILM": "Film [content]",
    "TYPE_MEDIA_SELECTION": "Selection [content]",
    "TYPE_PERSON": "Person [content]",
    "TYPE_GENRE": "Genre [content]",
    "OTHER_DIRECTOR": "Other director"
};

export default EN;
